import React from 'react';
import { graphql } from 'gatsby';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import Layout from '../components/layout';
import Rooms from '../templates/rooms';
import Facilities from '../templates/facilities';
import Instagram from '../templates/instagram';
import SEO from '../components/seo';
import Header from '../components/header';
import Banner from '../components/banner';

const IndexPage = ({
  data: {
    allContentfulRoom: { edges: rooms },
    allContentfulComfort: { edges: facilities },
    allContentfulContacts: { edges: rawContacts },
  },
  location,
}) => {
  const contacts = {};
  // eslint-disable-next-line no-return-assign
  rawContacts.forEach(({ node: { type, value } }) => (contacts[type] = value));
  return (
    <Layout>
      <SEO
        lang="ru"
        title="Главная"
        keywords={[
          'отель',
          'гостевой',
          'дом',
          'аренда',
          'аренда жилья',
          'аренда жилья в ялте 2019',
          'отдых в ялте 2019',
          'семейный отдых',
          'hotel',
          'guest',
          'house',
          'dom',
          'yalta',
          'гостевой дом',
          'guest house',
          'dom_yalta',
        ]}
      />
      <Helmet>
        <link rel="preload" href="/tour/terrace.jpeg" as="image" />
        <link rel="preload" href="/tour/pool.jpeg" as="image" />
      </Helmet>
      <Header contacts={contacts} location={location} />
      <main className="main">
        <Banner />
        <div className="container">
          {/* <Tour /> */}
          <Rooms items={rooms} />
          <Instagram />
          <Facilities items={facilities} />
        </div>
      </main>
    </Layout>
  );
};

export const query = graphql`
  query allRooms {
    allContentfulRoom(sort: { fields: [order], order: ASC }) {
      edges {
        node {
          id
          title
          prices
          maxPeople
          reserved
          promo
          order
          description {
            json
          }
          photos {
            file {
              url
            }
            fluid(maxWidth: 290, resizingBehavior: SCALE) {
              ...GatsbyContentfulFluid_tracedSVG
            }
          }
        }
      }
    }
    allContentfulContacts {
      edges {
        node {
          id
          type
          value
        }
      }
    }
    allContentfulComfort {
      edges {
        node {
          id
          title
          icon
          items
        }
      }
    }
  }
`;

IndexPage.propTypes = {
  data: PropTypes.shape({
    allContentfulRoom: PropTypes.shape({
      edges: PropTypes.array,
    }).isRequired,
    allContentfulComfort: PropTypes.shape({
      edges: PropTypes.array,
    }).isRequired,
    allContentfulContacts: PropTypes.shape({
      edges: PropTypes.array,
    }).isRequired,
  }).isRequired,
};

export default IndexPage;
